export const TAB_CHANGE = 'TAB_CHANGE';
export const TROLLBOX_TAB_SEEN = 'TROLLBOX_TAB_SEEN';
